var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeeklyPerformanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m482 180h-452c-16.569 0-30-13.431-30-30v-75c0-24.853 20.147-45 45-45h422c24.853 0 45 20.147 45 45v75c0 16.569-13.431 30-30 30z",
    fill: "#59abff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m467 30h-211v150h226c16.569 0 30-13.431 30-30v-75c0-24.853-20.147-45-45-45z",
    fill: "#4d87ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m467 512h-422c-24.853 0-45-20.147-45-45v-317h512v317c0 24.853-20.147 45-45 45z",
    fill: "#f3f5f9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 512h211c24.853 0 45-20.147 45-45v-317h-256z",
    fill: "#e1e6f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_3-tuesday_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m76 90c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z",
    fill: "#4d4d80"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m166 90c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z",
    fill: "#4d4d80"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 90c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z",
    fill: "#4d4d80"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m346 90c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z",
    fill: "#443d66"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436 90c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z",
    fill: "#443d66"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m271 75v-60c0-8.291-6.709-15-15-15v90c8.291 0 15-6.709 15-15z",
    fill: "#443d66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.002 256h-60c-8.291 0-15 6.709-15 15s6.709 15 15 15h40.781l-25.327 101.367c-2.021 8.027 2.871 16.172 10.913 18.179 7.938 2.008 16.158-2.794 18.179-10.913l30-120c1.128-4.482.117-9.229-2.725-12.861-2.841-3.648-7.207-5.772-11.821-5.772z",
    fill: "#4d4d80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.002 256h-30.002v30h10.783l-10.783 43.158v76.825c6.671.008 12.836-4.472 14.548-11.351l30-120c1.128-4.482.117-9.229-2.725-12.861-2.841-3.647-7.207-5.771-11.821-5.771z",
    fill: "#443d66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyPerformanceIcon);
export default __webpack_public_path__ + "static/media/weeklyPerformanceIcon.767a3333a43be556a313419f15d1e424.svg";
export { ForwardRef as ReactComponent };